<div class="wrapper">
  <div class="content">
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="62"
        height="54"
        viewBox="0 0 62 54"
        fill="none"
      >
        <path
          d="M27.7636 46.311H8.34458C7.49454 46.311 6.65281 46.1436 5.86747 45.8183C5.08213 45.493 4.36855 45.0162 3.76748 44.4151C2.55356 43.2012 1.87158 41.5547 1.87158 39.838V7.473C1.87158 5.75625 2.55356 4.10982 3.76748 2.8959C4.9814 1.68197 6.62784 1 8.34458 1H53.6556C55.3723 1 57.0188 1.68197 58.2327 2.8959C59.4466 4.10982 60.1286 5.75625 60.1286 7.473V26.892"
          stroke="#3F8140"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.87158 7.473L31.0006 26.892L60.1286 7.473M40.7096 46.311L47.1826 52.784L60.1286 39.838"
          stroke="#3F8140"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="header">Subscription Successful!</div>
    <div class="message-footer">
      <div class="message">
        <div>
          Thank you for your interest in our thought leadership. You’ll be
          receiving:
        </div>
        <ul>
          <li *ngFor="let item of topicTitles">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="footer">
        <span
          >If you have any questions or need to make changes to your
          subscription, please
          <a href="mailto:{{ contactEmail }}">email us</a>.</span
        >
        <span>Thank you!</span>
      </div>
    </div>
  </div>
</div>
